import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_CHECKOUT = 'checkout';

export interface ICmsConfigCheckoutDataContent {
    creditCardExpiredMessage?: string;
    showGiftReceiptCheckbox?: boolean;
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_CHECKOUT,
    name: 'Checkout Configuration',
    fields: [
        <NICmsContentField.IField>{
            key: 'sectionCreditCard',
            type: NICmsContentField.EFieldType.label,
            title: 'Credit Card'
        },
        <NICmsContentField.ITextField>{
            key: 'creditCardExpiredMessage',
            type: NICmsContentField.EFieldType.text,
            title: 'Expired message',
            default: 'This card has expired. Remove and another payment.'
        },
        <NICmsContentField.IField>{
            key: 'sectionGiftReceipt',
            type: NICmsContentField.EFieldType.label,
            title: 'Gift Receipt'
        },
        <NICmsContentField.IToggleField>{
            key: 'showGiftReceiptCheckbox',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Gift Receipt Checkbox',
            default: true
        }
    ]
});
